<template>
    <div class="col-12 col-md-6 col-lg-4">
        <b-card no-body class="apprentice-simple-card-with-banner"  @click="redirectSurveys">
            <b-card-img src="https://picsum.photos/600/300/?image=25" top class="banner"></b-card-img>
            <b-card-body body-class="body">
                <b-card-title title-tag="h5">Surveys</b-card-title>
                <div class="muted-text">
                    Some quick example text to build on the card title and make up the bulk of the card's content.
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "design-2021-survey-get-component",
    methods: {
        redirectSurveys(){
            window.location.href = this.routes.getSurveys();
        },
    }
}
</script>

<style scoped>

</style>
